// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Next = require("../../../reason/next/Next.bs.js");
let React = require("react");
let Loader = require("../../common/Components/Loader.bs.js");
let Scalars = require("../../../scalars/Scalars.bs.js");
let UTCDate = require("../../../reason/common/types/UTCDate.bs.js");
let Particles = require("../../../uikit/reason/Styles/Particles.bs.js");
let Link = require("next/link").default;
let MediaQuery = require("../../../reason/common/Media/MediaQuery.bs.js");
let ReactWindow = require("../../../reason/bindings/ReactWindow.bs.js");
let Stdlib_Date = require("@rescript/runtime/lib/js/Stdlib_Date.js");
let ReactWindow$1 = require("react-window");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let RelayRuntime = require("relay-runtime");
let TailwindMerge = require("tailwind-merge");
let GraphQLWSClient = require("../../../GraphQLWSClient.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelayReact = require("rescript-relay/src/RescriptRelayReact.bs.js");
let ConversationsListItem = require("./ConversationsListItem.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Subscriptions = require("rescript-relay/src/RescriptRelay_Subscriptions.bs.js");
let ReactVirtualizedAutoSizer = require("react-virtualized-auto-sizer").default;
let ReactWindowInfiniteLoader = require("react-window-infinite-loader").default;
let ConversationsListRelay_query_graphql = require("../../../__generated__/ConversationsListRelay_query_graphql.bs.js");
let ConversationsListRelayPaginationQuery_graphql = require("../../../__generated__/ConversationsListRelayPaginationQuery_graphql.bs.js");
let ConversationPageConversationMessages_conversation_graphql = require("../../../__generated__/ConversationPageConversationMessages_conversation_graphql.bs.js");
let ConversationsListRelay_ConversationEventsSubscription_graphql = require("../../../__generated__/ConversationsListRelay_ConversationEventsSubscription_graphql.bs.js");

let getConnectionNodes = ConversationsListRelay_query_graphql.Utils.getConnectionNodes;

let convertFragment = ConversationsListRelay_query_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationsListRelay_query_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationsListRelay_query_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ConversationsListRelay_query_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationsListRelay_query_graphql.node, convertFragment, fRef);
}

let makeRefetchVariables = ConversationsListRelayPaginationQuery_graphql.Types.makeRefetchVariables;

let convertRefetchVariables = ConversationsListRelayPaginationQuery_graphql.Internal.convertVariables;

function useRefetchable(fRef) {
  return RescriptRelay_Fragment.useRefetchableFragment(ConversationsListRelay_query_graphql.node, convertFragment, convertRefetchVariables, fRef);
}

function usePagination(fRef) {
  return RescriptRelay_Fragment.usePaginationFragment(ConversationsListRelay_query_graphql.node, fRef, convertFragment, convertRefetchVariables);
}

let QueryFragment = {
  getConnectionNodes: getConnectionNodes,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment,
  makeRefetchVariables: makeRefetchVariables,
  convertRefetchVariables: convertRefetchVariables,
  useRefetchable: useRefetchable,
  usePagination: usePagination
};

let convertVariables = ConversationsListRelay_ConversationEventsSubscription_graphql.Internal.convertVariables;

let convertResponse = ConversationsListRelay_ConversationEventsSubscription_graphql.Internal.convertResponse;

let subscribe = RescriptRelay_Subscriptions.subscribe(ConversationsListRelay_ConversationEventsSubscription_graphql.node, convertVariables, convertResponse);

let Subscription = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  subscribe: subscribe
};

let InfiniteLoader = ReactWindow.InfiniteLoader(ReactWindow.FixedSizeInstance);

function ConversationsListRelay$FixedDimensionsComponent(props) {
  let loadMore = props.loadMore;
  let hasNextPage = props.hasNextPage;
  let items = props.items;
  let selectedConversationId = props.selectedConversationId;
  let width = props.width;
  let height = props.height;
  let itemCount = hasNextPage ? items.length + 1 | 0 : items.length;
  let isItemLoaded = idx => {
    if (hasNextPage) {
      return idx < items.length;
    } else {
      return true;
    }
  };
  let loadMore$1 = (param, param$1) => loadMore();
  return JsxRuntime.jsx(ReactWindowInfiniteLoader, {
    isItemLoaded: isItemLoaded,
    itemCount: itemCount,
    loadMoreItems: loadMore$1,
    children: param => JsxRuntime.jsx(ReactWindow$1.FixedSizeList, {
      height: height,
      width: width,
      itemCount: itemCount,
      itemSize: 98.0,
      onItemsRendered: param.onItemsRendered,
      ref: param.ref,
      overscanCount: 5,
      children: param => {
        let item = items[param.index];
        let tmp;
        if (item !== undefined) {
          let selected = selectedConversationId !== undefined ? selectedConversationId === item.id : false;
          tmp = JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(Link, {
              href: `/conversations/` + item.id,
              className: "text-inherit hover:text-inherit active:text-inherit focus:text-inherit",
              children: JsxRuntime.jsx(ConversationsListItem.make, {
                conversation: item.fragmentRefs
              })
            }),
            className: TailwindMerge.twMerge([
              "border-l-2 border-l-transparent border-b h-24",
              selected ? "border-l-tan-gold bg-gray-50" : ""
            ])
          }, item.id);
        } else {
          tmp = JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(Loader.make, {
              size: "small"
            }),
            className: "h-24"
          });
        }
        return JsxRuntime.jsx("div", {
          children: tmp,
          style: param.style
        });
      }
    })
  });
}

let FixedDimensionsComponent = {
  InfiniteLoader: InfiniteLoader,
  make: ConversationsListRelay$FixedDimensionsComponent
};

function ConversationsListRelay$AutosizedComponent(props) {
  let loadMore = props.loadMore;
  let items = props.items;
  let hasNextPage = props.hasNextPage;
  let selectedConversationId = props.selectedConversationId;
  return JsxRuntime.jsx(ReactVirtualizedAutoSizer, {
    children: param => JsxRuntime.jsx(ConversationsListRelay$FixedDimensionsComponent, {
      height: param.height,
      width: param.width,
      selectedConversationId: selectedConversationId,
      items: items,
      hasNextPage: hasNextPage,
      loadMore: loadMore
    })
  });
}

let AutosizedComponent = {
  make: ConversationsListRelay$AutosizedComponent
};

function useSelectFirstConversationOnDesktop(skipOpt, conversations, selectedConversationId) {
  let skip = skipOpt !== undefined ? skipOpt : false;
  let isDesktop = MediaQuery.useMediaQuery({
    TAG: "MinWidth",
    _0: Particles.Breakpoint.lg
  });
  let router = Next.useRouter();
  React.useEffect(() => {
    if (skip) {
      return;
    }
    let match = conversations[0];
    if (isDesktop && selectedConversationId === undefined && match !== undefined) {
      Next.Router.replace("/conversations/" + match.id, undefined, undefined, router);
    }
  }, [
    skip,
    conversations,
    isDesktop
  ]);
}

function ConversationsListRelay(props) {
  let selectedConversationId = props.selectedConversationId;
  let match = usePagination(props.query);
  let refetch = match.refetch;
  let loadNext = match.loadNext;
  let match$1 = React.useTransition();
  let startTransition = match$1[1];
  let items = getConnectionNodes(match.data.accountConversations);
  let selectedConversationIdRef = React.useRef(selectedConversationId);
  selectedConversationIdRef.current = selectedConversationId;
  useSelectFirstConversationOnDesktop(props.isNewConversation, items, selectedConversationId);
  items.sort((v1, v2) => {
    let match = v1.lastMessage;
    if (match === undefined) {
      return 0;
    }
    let match$1 = v2.lastMessage;
    if (match$1 !== undefined) {
      return Stdlib_Date.compare(UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(match$1.sentAt)), UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(match.sentAt)));
    } else {
      return 0;
    }
  });
  let numItems = items.length;
  let refetchConversationList = React.useCallback(() => startTransition(() => {
    refetch(makeRefetchVariables(undefined, Primitive_option.some(numItems)), "network-only", undefined);
  }), [
    refetch,
    startTransition,
    numItems
  ]);
  let wsIsClosed = React.useRef(false);
  let onWsStatusUpdated = React.useCallback(status => {
    let match = wsIsClosed.current;
    switch (status) {
      case "Closed" :
        wsIsClosed.current = true;
        return;
      case "Connecting" :
        return;
      case "Connected" :
        if (match) {
          refetchConversationList();
          wsIsClosed.current = false;
          return;
        } else {
          return;
        }
    }
  }, [refetchConversationList]);
  GraphQLWSClient.useOnWsStatusUpdated(onWsStatusUpdated);
  let environment = RescriptRelayReact.useEnvironmentFromContext();
  React.useEffect(() => {
    let subscription = subscribe(environment, {
      connections: [ConversationsListRelay_query_graphql.makeConnectionId(RelayRuntime.ROOT_ID)]
    }, undefined, undefined, undefined, (store, response) => {
      let match = response.conversationEvents;
      if (match === undefined) {
        return;
      }
      switch (match.__typename) {
        case "NewConversationReplyEvent" :
          let match$1 = match.conversation;
          if (match$1 === undefined) {
            return;
          }
          let match$2 = match.message;
          if (match$2 === undefined) {
            return;
          }
          let conversationDataId = match$1.__id;
          let match$3 = store.get(match$2.__id);
          let match$4 = store.get(conversationDataId);
          if (!(match$3 == null) && !(match$4 == null)) {
            match$4.setLinkedRecord(match$3, "lastMessage");
            if (selectedConversationIdRef.current !== match$1.id) {
              return Stdlib_Option.forEach(Primitive_option.fromNullable(store.get(ConversationPageConversationMessages_conversation_graphql.makeConnectionId(conversationDataId))), conversationMessageConnectionProxy => {
                conversationMessageConnectionProxy.invalidateRecord();
              });
            } else {
              return;
            }
          } else {
            return;
          }
        case "NewConversationEvent" :
        case "__unselected" :
          return;
      }
    });
    return () => {
      subscription.dispose();
    };
  }, []);
  return JsxRuntime.jsx(ConversationsListRelay$AutosizedComponent, {
    selectedConversationId: selectedConversationId,
    hasNextPage: match.hasNext,
    items: items,
    loadMore: () => new Promise((resolve, reject) => {
      loadNext(10, e => {
        if (e !== undefined) {
          return reject();
        } else {
          return resolve();
        }
      });
    })
  });
}

let cardHeight = 98.0;

let make = ConversationsListRelay;

exports.QueryFragment = QueryFragment;
exports.Subscription = Subscription;
exports.cardHeight = cardHeight;
exports.FixedDimensionsComponent = FixedDimensionsComponent;
exports.AutosizedComponent = AutosizedComponent;
exports.useSelectFirstConversationOnDesktop = useSelectFirstConversationOnDesktop;
exports.make = make;
/* subscribe Not a pure module */
